module.exports = __webpack_public_path__ + "static/media/az.892b4c9a.svg";